import styles from "./style.module.scss";
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { MouseEventHandler, ReactNode, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export type MenuActionProps = {
  isVisible?: boolean
  actionTitle?: string
  customElement?: ReactNode,
  onClick?: MouseEventHandler,
  href?: string,
  target?: "_blank" | "_self" | "_parent" | "_top",
  color?: string,
  formId?: string,
  type?: "submit" | "reset" | "button" | undefined;
  disabled?: boolean;
} & React.RefAttributes<HTMLAnchorElement>;

type DropdownActionsMenuProps = {
  actions?: MenuActionProps[];
  isInvalid?: boolean;
};

const DropdownActionsMenu = (props: DropdownActionsMenuProps) => {
  const navigate = useNavigate();
  const { actions = [], isInvalid = false } = props;
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const renderAction = (action: MenuActionProps): ReactNode => {
    const { isVisible = true } = action
    let onClickEvent;
    if (action.href) {
      if (action.target === "_blank") {
        onClickEvent = () => window.open(`${action.href}`, '_blank')
      } else {
        onClickEvent = () => navigate(`${action.href}`)
      }
    } else {
      onClickEvent = action.onClick
    }
    return isVisible && (
      <DropdownItem onClick={onClickEvent} target={action.target}>
        {action.actionTitle}
      </DropdownItem>
    )
  }

  return (
    <>
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
        <DropdownToggle
          tag="span"
          data-toggle="dropdown"
          aria-expanded={dropdownOpen}
        >
          <Button color={isInvalid ? "danger" : "primary"} type="button">
            <FontAwesomeIcon icon={faEllipsisVertical} />
          </Button>
        </DropdownToggle>
        <DropdownMenu className={styles.dropdownMenu}>
          {
            actions.map(a => {
              return renderAction(a);
            })
          }
        </DropdownMenu>
      </Dropdown>
    </>
  );
}

export default DropdownActionsMenu;